import { action, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { getStorage, saveLocalStorage } from '@/utils/browsers';
import { DevicesScreen, WindowSize } from '@/hooks/useWindowSize';

export default class UIStore extends BaseStore {
    isOpenSidebar: boolean = getStorage('isOpenSidebar') === 'true';

    devicesScreen: DevicesScreen = {
        mobile: false,
        desktop: false
    };

    windowSize: WindowSize = {
        width: window.innerWidth,
        height: window.innerHeight
    };

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            devicesScreen: observable,
            windowSize: observable,
            isOpenSidebar: observable,
            setOpenSidebar: action.bound,
            setDevicesScreen: action.bound,
            setWindowSize: action.bound
        });
    }

    setOpenSidebar(value?: boolean) {
        if (value === undefined) {
            this.isOpenSidebar = !this.isOpenSidebar;
        } else {
            this.isOpenSidebar = value;
        }
        saveLocalStorage('isOpenSidebar', String(this.isOpenSidebar));
    }

    setDevicesScreen(value: DevicesScreen) {
        this.devicesScreen = value;
    }

    setWindowSize(value: WindowSize) {
        this.windowSize = value;
    }
}
